var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 -1.39567e-06C7.16367 -2.16819e-06 0.000225331 7.16344 0.000224559 16C0.000223786 24.8366 7.16367 32 16.0002 32C24.3558 32 31.2154 25.5952 31.9374 17.4272L16.2701 17.4272L20.0353 21.0143C20.3415 21.3049 20.3477 21.7892 20.0478 22.086L19.3541 22.7797C19.0604 23.0734 18.5854 23.0734 18.2948 22.7797L12.2205 16.7085C11.9268 16.4148 11.9268 15.9398 12.2205 15.6493L18.2948 9.57493C18.5886 9.28122 19.0635 9.28122 19.3541 9.57493L20.0478 10.2686C20.3446 10.5654 20.3384 11.0498 20.0353 11.3404L16.2701 14.9275L31.9648 14.9275C31.4131 6.59101 24.4764 -6.54664e-07 16.0002 -1.39567e-06Z",
    fill: "#007499"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.5c6a24f53f38627502255f990f56dea8.svg";
export { ForwardRef as ReactComponent };